export const actionTypes = {
    INITIAL_STORE_FILTERS: 'INITIAL_STORE_FILTERS',
    UPDATE_STORE_FILTERS: 'UPDATE_STORE_FILTERS',
    CLEAR_STORE_FILTERS: 'CLEAR_STORE_FILTERS',
    SAGA_FETCH_STORE_EQUIPMENTS: 'SAGA_FETCH_STORE_EQUIPMENTS',
    FETCH_STORE_EQUIPMENTS_SUCCESS: 'FETCH_STORE_EQUIPMENTS_SUCCESS',
    FETCH_STORE_MARKETPLACES_SUCCESS: 'FETCH_STORE_MARKETPLACES_SUCCESS',
    SAGA_FETCH_STORE_MARKETPLACES: 'SAGA_FETCH_STORE_MARKETPLACES',
    MARKETPLACES_LOADING_START: 'MARKETPLACES_LOADING_START',
    MARKETPLACES_LOADING_END: 'MARKETPLACES_LOADING_END',
    EQUIPMENTS_LOADING_START: 'EQUIPMENTS_LOADING_START',
    EQUIPMENTS_LOADING_END: 'EQUIPMENTS_LOADING_END',
    STORE_LOADING_START: 'STORE_LOADING_START',
    STORE_LOADING_END: 'STORE_LOADING_END',
    STORE_CITIES_LOADING_START: 'STORE_CITIES_LOADING_START',
    STORE_CITIES_LOADING_END: 'STORE_CITIES_LOADING_END',
    STORE_ZIP_CODES_LOADING_START: 'STORE_ZIP_CODES_LOADING_START',
    STORE_ZIP_CODES_LOADING_END: 'STORE_ZIP_CODES_LOADING_END',
    SAGA_FETCH_STORES: 'SAGA_FETCH_STORES',
    SAGA_FETCH_STORES_SUCCESS: 'SAGA_FETCH_STORES_SUCCESS',
    STORE_ERROR: 'STORE_ERROR',
    SAGA_FETCH_STORE_BY_ID: 'SAGA_FETCH_STORE_BY_ID',
    FETCH_STORE_BY_ID_SUCCESS: 'FETCH_STORE_BY_ID_SUCCESS',
    FETCH_STORE_BY_ID_FAILED: 'FETCH_STORE_BY_ID_FAILED',
    SAGA_FETCH_STORE_CITIES: 'SAGA_FETCH_STORE_CITIES',
    SAGA_FETCH_STORE_POSTAL_CODE: 'SAGA_FETCH_STORE_POSTAL_CODE',
    DISPATCH_CLEAR_STORE_FILTERS: 'DISPATCH_CLEAR_STORE_FILTERS',
    FETCH_STORE_DEVICES_SUCCESS: 'FETCH_STORE_DEVICES_SUCCESS',
    SAGA_FETCH_STORE_DEVICES: 'SAGA_FETCH_STORE_DEVICES',
}

export const initializeStoreFilters = filters => ({
    type: actionTypes.INITIAL_STORE_FILTERS,
    payload: filters,
})

export const dispatchStoreFilters = filters => ({
    type: actionTypes.UPDATE_STORE_FILTERS,
    payload: filters,
})

export const clearStoreFilters = () => ({
    type: actionTypes.CLEAR_STORE_FILTERS,
})

export const sagaFetchEquipments = () => ({
    type: actionTypes.SAGA_FETCH_STORE_EQUIPMENTS,
})

export const sagaFetchMarketplaces = () => ({
    type: actionTypes.SAGA_FETCH_STORE_MARKETPLACES,
})

export const fetchMarketplaceSuccess = payload => ({
    type: actionTypes.FETCH_STORE_MARKETPLACES_SUCCESS,
    payload,
})

export const fetchStoreEquipmentsSuccess = data => ({
    type: actionTypes.FETCH_STORE_EQUIPMENTS_SUCCESS,
    payload: data,
})

export const equipmentsLoadingStart = () => ({
    type: actionTypes.EQUIPMENTS_LOADING_START,
})

export const equipmentsLoadingEnd = () => ({
    type: actionTypes.EQUIPMENTS_LOADING_END,
})

export const marketplaceLoadingStart = () => ({
    type: actionTypes.MARKETPLACES_LOADING_START,
})

export const marketplaceLoadingEnd = () => ({
    type: actionTypes.MARKETPLACES_LOADING_END,
})

export const storesLoadingStart = () => ({
    type: actionTypes.STORE_LOADING_START,
})

export const storesLoadingEnd = () => ({
    type: actionTypes.STORE_LOADING_END,
})

export const storeCitiesLoadingStart = () => ({
    type: actionTypes.STORE_CITIES_LOADING_START,
})

export const storeCitiesLoadingEnd = () => ({
    type: actionTypes.STORE_CITIES_LOADING_END,
})

export const storeZipCodesLoadingStart = () => ({
    type: actionTypes.STORE_ZIP_CODES_LOADING_START,
})

export const storeZipCodesLoadingEnd = () => ({
    type: actionTypes.STORE_ZIP_CODES_LOADING_END,
})

export const fetchStores = data => ({
    type: actionTypes.SAGA_FETCH_STORES,
    payload: data,
})

export const fetchStoresSuccess = data => ({
    type: actionTypes.SAGA_FETCH_STORES_SUCCESS,
    payload: data,
})

export const setStoreError = data => ({
    type: actionTypes.STORE_ERROR,
    payload: data,
})

export const sagasFetchStoreByID = payload => ({
    type: actionTypes.SAGA_FETCH_STORE_BY_ID,
    payload,
})

export const fetchStoreByIDSuccess = payload => ({
    type: actionTypes.FETCH_STORE_BY_ID_SUCCESS,
    payload,
})

export const fetchStoreByIDFailed = () => ({
    type: actionTypes.FETCH_STORE_BY_ID_FAILED,
})

export const sagaFetchStoreCities = () => ({
    type: actionTypes.SAGA_FETCH_STORE_CITIES,
})

export const sagaFetchStorePostalCodes = () => ({
    type: actionTypes.SAGA_FETCH_STORE_POSTAL_CODE,
})

export const dispatchClearAllFilters = () => ({
    type: actionTypes.DISPATCH_CLEAR_STORE_FILTERS,
})

export const sagaFetchDevices = () => ({
    type: actionTypes.SAGA_FETCH_STORE_DEVICES,
})

export const fetchDevicesSuccess = payload => ({
    type: actionTypes.FETCH_STORE_DEVICES_SUCCESS,
    payload,
})
